import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardControlKeyIcon from '@mui/icons-material/KeyboardControlKey';
import React, { useEffect, useMemo, useState } from 'react';
import ComponentSubHeader from '../../../Headers/ComponentSubHeader';
import styles from './Accordions.module.scss';

interface IAccordionCardProps {
    title: string | JSX.Element;
    disabled?: boolean;
    component: JSX.Element | null;
    open?: boolean;
    type?: 'gray' | 'white';
}

const CardAccordion = (props: IAccordionCardProps) => {
    const [accordionOpen, setAccordionOpen] = useState<boolean>();

    useEffect(() => {
        if (!props.open) {
            return;
        }

        setAccordionOpen(props.open ?? false);
    }, [props.open]);

    const accordianTopLevelClass = useMemo(() => {
        if (props.disabled) {
            return styles.card_accordion_disabled;
        }

        if (props.type === 'gray') {
            return styles.card_accordion_gray;
        }

        return styles.card_accordion;
    }, [props.disabled, props.type]);

    return (
        <div className={accordianTopLevelClass}>
            <button
                type="button"
                onClick={() => {
                    if (props.disabled) {
                        return;
                    }

                    setAccordionOpen(!accordionOpen);
                }}
            >
                <ComponentSubHeader
                    title={props.title}
                    containerClassName={styles.card_accordion_subheader}
                    rightSideComponent={
                        accordionOpen ? (
                            <KeyboardControlKeyIcon className={styles.card_accordion_button} fontSize="large" />
                        ) : (
                            <KeyboardArrowDownIcon className={styles.card_accordion_button} fontSize="large" />
                        )
                    }
                />
            </button>
            {accordionOpen && <div className={styles.card_accordion_conditional_component}>{props.component}</div>}
        </div>
    );
};

export default CardAccordion;
